<template>
  <div class="lht-layout">
    <el-dialog
      title="联合体"
      :visible.sync="visible"
      width="40%"
      lock-scroll
      :close-on-click-modal="false"
      @close="close"
    >
      <table-tem
        v-loading="loading"
        :config="tableConfig"
        :key="tableConfig.key"
        @changePage="changePage"
        @changePages="changePages"
      >
      </table-tem>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableTem from "../tableTem/index.vue";
export default {
  data() {
    return {
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "qymc",
            title: "投标单位",
            align: "center",
          },
          {
            key: "qydm",
            title: "统一组织机构代码",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
        key: 1
      },
      loading:false,
    };
  },
  props: ["visible","lhtId"],
  components: {
    tableTem,
  },
  mounted(){
    this.getData()
  },
  methods: {
    close(){
      this.$emit("update:visible",false)
    },
    async getData() {
      this.loading = true
      let params = {
        lhtId: this.lhtId,
        pageSize: this.tableConfig.pageSize,
        page:this.tableConfig.currentPage
      }
      try {
        const res = await this.$api.getLhtqyData(params)
        if(res.data.code == 200){
          this.loading = false
          this.tableConfig.data = res.data.data
          this.tableConfig.total = res.data.total
          this.tableConfig.key++
        }else{
          this.loading = false
        }
      } catch (error) {
        console.log(error);
        this.loading = false
      }
    },
    // 分页功能
    changePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },
    changePages(e) {
      this.tableConfig.pageSize = e;
      this.getData();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.lht-layout {
}
</style>